import { Container } from 'inversify';
import { addressesBindings } from 'src/bindings/addressBindings';
import { authBindings } from 'src/bindings/authBindings';
import { bannersBindings } from 'src/bindings/bannersBindings';
import { cartBindings } from 'src/bindings/cartBindings';
import { categoriesBindings } from 'src/bindings/categoriesBindings';
import { checkoutBindings } from 'src/bindings/checkoutBindings';
import { commonBindings } from 'src/bindings/commonBindings';
import { idVerificationBindings } from 'src/bindings/idVerificationBindings';
import { notificationsBindings } from 'src/bindings/notificationsBindings';
import { ordersBindings } from 'src/bindings/ordersBindings';
import { paymentMethodsBindings } from 'src/bindings/paymentMethodsBindings';
import { productsBindings } from 'src/bindings/productsBindings';
import { profileBindings } from 'src/bindings/profileBindings';
import { walletBindings } from 'src/bindings/walletBindings';
import { brandsBindings } from 'src/bindings/brandsBindings';
import { reviewsBindings } from 'src/bindings/reviewsBindings';
import { npsBindings } from 'src/bindings/npsBindings';

const diContainer = new Container();

diContainer.load(
  commonBindings,
  addressesBindings,
  authBindings,
  bannersBindings,
  cartBindings,
  categoriesBindings,
  checkoutBindings,
  notificationsBindings,
  ordersBindings,
  paymentMethodsBindings,
  productsBindings,
  profileBindings,
  walletBindings,
  idVerificationBindings,
  brandsBindings,
  reviewsBindings,
  npsBindings
);

export { diContainer };
